<template>
    <div class="vod-webinar">
        <div class="primary-column">
            <div v-if="!isMobile" class="vod-webinar-player">
                <div class="vod-webinar-loading" v-if="loading">
                    <ListLoader />
                </div>
                <div class="vod-video-placeholder" v-if="videoPlaceholder">
                    <img
                        @show="loading = false"
                        :src="videoPlaceholder"
                        alt=""
                    />
                </div>
                <vimeo-player
                    @loaded="loading = false"
                    :options="{ responsive: true }"
                    autoplay="true"
                    :video-id="0"
                    :video-url="videoUrl"
                    v-if="videoUrl"
                />
                <youtube
                    player-width="100%"
                    player-height="100%"
                    class="youtbue-player"
                    :player-vars="{ autoplay: 1 }"
                    @ready="loading = false"
                    v-if="livestreamUrl"
                    :video-id="livestreamUrl"
                />
            </div>
            <div v-if="isMobile" class="webinar-thumbnail">
                <img :src="currentWebinar.thumbnail" alt="" />
            </div>
            <div class="webinar-header">
                <div v-if="currentWebinar.subtitle" class="webinar-subtitle">
                    <h3>{{ currentWebinar.subtitle }}</h3>
                </div>
                <div v-if="currentWebinar.title" class="webinar-title">
                    <h2>{{ currentWebinar.title }}</h2>
                </div>
                <div
                    class="webinar-certificate-button"
                    @click="goToYoutube"
                    v-if="
                        livestreamUrl &&
                            !currentWebinar.certificate_title &&
                            !isMobile
                    "
                >
                    <i class="material-icons">chat</i>
                    {{ 'Dołącz do chatu' }}
                </div>
                <div
                    class="webinar-certificate-button"
                    @click="showCertificate"
                    v-if="certificateLabel && !isMobile"
                >
                    <i class="material-icons">check_circle_outline</i>
                    {{ certificateLabel }}
                </div>
            </div>
            <div
                class="vod-webinar-description"
                v-html="currentWebinar.description"
                v-if="currentWebinar.description"
            ></div>
            <VodAttachments
                style="margin-left: 0;"
                v-if="webinarAttachments"
                :attachments="webinarAttachments"
            />
            <WebinarHost
                v-if="currentWebinar.author_name"
                :content="currentWebinar"
            />
            <div v-if="isMobile" class="button-container">
                <Button title="Zakup bilet" @click="showCertificate" />
            </div>
        </div>
        <div class="secondary-column" v-if="otherWebinars.length > 0">
            <div class="vod-webinars-title">
                {{
                    currentWebinar.type == 'vod-conference'
                        ? 'Szkolenia w ramach konferencji'
                        : otherWebinarsLabel
                }}
            </div>
            <div v-if="!isMobile" class="other-webinars-wrapper">
                <div
                    class="vod-webinar-thumbnail"
                    v-for="webinar in otherWebinars"
                    :key="webinar.uuid"
                    @click="goToWebinar(webinar)"
                >
                    <v-img :url="webinar.thumbnail" fit="cover" size="medium" />
                </div>
            </div>
            <div v-else class="other-webinars-wrapper">
                <div
                    class="conference-webinar"
                    v-for="webinar in otherWebinars"
                    :key="webinar.uuid"
                >
                    <VodCertificatePaymentContent :webinar="webinar" />
                    <Button
                        title="Zakup bilet"
                        @click="selectWebinar(webinar)"
                    />
                </div>
            </div>
        </div>
        <transition name="fade">
            <!-- //! NOTE: change sec condition after update of prices -->
            <VodCertificate
                :webinar="
                    Object.keys(selectedWebinar).length != 0
                        ? selectedWebinar
                        : currentWebinar
                "
                :conferenceWebinar="
                    Object.keys(selectedWebinar).length != 0 && false
                        ? currentWebinar
                        : null
                "
                v-if="certificateVisible"
                @close="closeCertificate"
            />
        </transition>
    </div>
</template>
<script>
export default {
    components: {
        VodCertificate: () => import('./VodCertificate'),
        VodCertificatePaymentContent: () =>
            import('./VodCertificatePaymentContent'),
        WebinarHost: () => import('./WebinarHost'),
        VodAttachments: () => import('@/components/utils/VodAttachments.vue')
    },
    data() {
        return {
            loading: true,
            certificateVisible: false,
            paymentVisible: false,
            selectedWebinar: {}
        }
    },
    computed: {
        isMobile() {
            return this.$store.getters['source/isMobile']
        },
        webinarAttachments() {
            return this.currentWebinar.attachments && this.isProductPaid
                ? this.currentWebinar.attachments
                : null
        },
        videoPlaceholder() {
            return !this.livestreamUrl &&
                !this.videoUrl &&
                this.currentWebinar.preview_image
                ? this.currentWebinar.preview_image
                : null
        },
        otherWebinarsLabel() {
            return this.currentWebinar.conference
                ? 'Inne szkolenia w ramach konferencji'
                : 'Podobne webinary'
        },
        livestreamUrl() {
            return this.currentWebinar.livestream_url && this.isProductPaid
                ? this.currentWebinar.livestream_url
                : null
        },
        videoUrl() {
            if (this.currentWebinar.conference) {
                return this.isProductPaid && this.currentWebinar.video_url
                    ? this.currentWebinar.video_url
                    : this.currentWebinar.preview_url
            }
            if (this.currentWebinar.livestream_url) {
                return this.isProductPaid
                    ? null
                    : this.currentWebinar.preview_url
            }
            return this.currentWebinar.video_url
                ? this.currentWebinar.video_url
                : null
        },
        isProductPaid() {
            const boughtItems = this.$store.state.boughtItems
            return boughtItems.some(
                item =>
                    item.uuid == this.currentWebinar.uuid ||
                    item.uuid == this.currentWebinar.conference
            )
        },
        certificateLabel() {
            if (!this.currentWebinar.conference && !this.currentWebinar.cost) {
                return false
            }
            switch (true) {
                case this.currentWebinar.livestream_url &&
                    !this.currentWebinar.certificate_title:
                    return !this.isProductPaid ? 'Kup bilet' : false
                case this.$Utils.isWinterInspiration(
                    this.currentWebinar.conference
                ):
                    return !this.isProductPaid ? 'Odblokuj księgę' : false
                default:
                    return this.isProductPaid
                        ? 'Zobacz certyfikat'
                        : 'Zdobądź certyfikat'
            }
        },
        uuid() {
            return this.$route.params.uuid
        },
        otherWebinars() {
            if (
                this.currentWebinar.conference ||
                this.currentWebinar.type == 'vod-conference'
            ) {
                const webinars = this.$store.getters[
                    'content/webinarsByConference'
                ](this.currentWebinar.conference || this.currentWebinar.uuid)
                return webinars.filter(w => w.uuid != this.uuid)
            }
            if (this.isMobile) return []
            const webinars = this.$store.state.content.webinars
            return webinars.filter(w => w.uuid != this.uuid && !w.conference)
        },
        currentWebinar() {
            return this.$store.getters['content/productByUUID'](this.uuid)
        }
    },
    methods: {
        goToYoutube() {
            const url = `https://www.youtube.com/watch?v=${this.currentWebinar.livestream_url}`
            window.open(url, '_blank')
        },
        closeWarning() {
            this.$store.commit('hideWarning')
        },
        showCertificate() {
            this.certificateVisible = true
        },
        goToWebinar(webinar) {
            this.$router.replace(`/webinar/${webinar.uuid}`)
        },
        selectWebinar(webinar) {
            this.selectedWebinar = {}
            this.selectedWebinar = webinar
            this.showCertificate()
        },
        closeCertificate() {
            this.certificateVisible = false
            this.selectedWebinar = {}
        }
    },
    mounted() {
        if (
            this.currentWebinar.certificate_title ||
            this.currentWebinar.livestream_url
        ) {
            if (this.$route.query.transaction) {
                this.certificateVisible = true
                this.$query.removeQuery('transaction')
            }
            if (this.$route.query.checkout_modal) {
                this.certificateVisible = true
                this.$query.removeQuery('checkout_modal')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
p {
    max-width: 50rem;
    font-size: 1.2rem;
    line-height: 1.4rem;
    margin-top: 0;
}
h2 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 2.5rem;
}
.vod-webinar {
    min-height: 100%;
    width: 100%;
    flex: 1;
    padding: 5rem 15rem;
    display: flex;
}
.primary-column {
    flex: 4;
    margin-right: 2rem;
}
.secondary-column {
    flex: 1;
}
.webinar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1rem;
}
.webinar-title {
    font-size: 3rem;
    margin-top: 1rem;
}
.vod-webinar-thumbnail {
    margin-top: 1rem;
    width: 100%;
    transition: $ease;
    cursor: pointer;

    &:hover {
        transform: scale(1.01);
    }

    img {
        width: 100%;
    }
}
.vod-certificate {
    color: #333;
}
.youtbue-player {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}
@media (max-width: 1000px) {
    p {
        font-size: 1.4rem;
        line-height: 1.6rem;
    }
    .vod-webinar {
        flex-direction: column;
        padding: 5rem 2rem;
        padding-bottom: 0;
    }
    .primary-column {
        margin: 0;
        padding-bottom: 1rem;
    }
    .secondary-column {
        background-color: #f0f5f6;
        margin: 0 -2rem;
        padding: 0 2rem;
        padding-bottom: 2rem;
    }
    .webinar-title {
        margin-top: 0;
        max-width: 85%;
        h2 {
            font-size: 1.5rem;
            line-height: 120%;
            font-family: $input-family;
        }
    }
    .webinar-subtitle {
        margin-top: 0;
        h3 {
            margin-top: -0.25rem;
            margin-bottom: 0;
            font-size: 1rem;
            font-family: $input-family;
            color: $accent-apple;
        }
    }
    .vod-webinar-description {
        font-size: 1rem;
        font-family: $input-family;
        color: $smoked;
        line-height: 150%;
    }
    .webinar-certificate-button {
        font-size: 1rem;
        margin-top: 1rem;
        padding: 0.4rem 0.8rem;
        margin-left: auto;

        i {
            font-size: 1.5rem;
        }
    }
    .vod-webinar-author {
        flex-direction: column;
    }
    .vod-webinars-title {
        margin-top: 2rem;
        font-size: 1.2rem;
        font-family: $input-family;
    }
    .webinar-thumbnail {
        margin-top: -5rem;
        margin-left: -2rem;
        margin-right: -2rem;
        img {
            width: 100%;
        }
    }
    .conference-webinar {
        margin-top: 1rem;
        background-color: #fff;
        border-radius: 10px;
        padding: 1rem;
    }
}
</style>
